import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeLimit',
    standalone: true
})
export class TimeLimitPipe implements PipeTransform {
    transform(secondsLeft?: number | Date): string {
        let endDate = new Date(secondsLeft || 0);
        if (typeof secondsLeft === 'number') {
            endDate = new Date();
            endDate.setSeconds(endDate.getSeconds() + Math.round(secondsLeft) + 1);
        }

        return endDate.toUTCString();
    }
}
